import { G__Spinner as g__spinner } from './g--spinner/directive';
import { G__ProductsModule } from './g--products/index';

export const General = {
    directives: {
        g__spinner
    },
    modules: {
        G__ProductsModule
    }
};
